import { Fragment } from 'react';

import PropTypes from 'prop-types';
import { NON_BREAKING_SPACE } from 'utils/constants/common';

import { H2Section } from 'bloko/blocks/header';
import Text, { TextSize } from 'bloko/blocks/text';
import VSpacing from 'bloko/blocks/vSpacing';

import useTrls from 'hooks/translation/useTrls';

import InvoiceStatus from 'components/InvoiceStatus';
import KMNumber from 'components/KMNumber';

import AutoInvoice from 'components/Admin/Invoices/InvoicesTable/Invoice/Payer/AutoInvoice';

import { InvoiceDreamPayerType } from 'store/models/invoices';

import 'components/Admin/InvoiceDetail/Invoice/TitleWithStatus/TitleWithStatus.less';

const TitleWithStatus = ({ invoice }) => {
    const trl = useTrls();

    if (!invoice) {
        return null;
    }
    return (
        <Fragment>
            <H2Section lite>
                {invoice.payerType !== InvoiceDreamPayerType.HH ? (
                    <span>
                        {trl('admin.Invoices.InvoicesDetail.Invoice.Title.number')}
                        {NON_BREAKING_SPACE}
                    </span>
                ) : (
                    <span>{invoice.title}</span>
                )}
                {NON_BREAKING_SPACE}
                <Text Element="span" size={TextSize.ExtraLarge}>
                    <KMNumber {...invoice} />
                </Text>
                <span className="invoice-title__status">
                    <AutoInvoice {...invoice} />
                    {NON_BREAKING_SPACE}
                    <InvoiceStatus {...invoice} />
                </span>
            </H2Section>
            <VSpacing base={4} />
        </Fragment>
    );
};

TitleWithStatus.propTypes = {
    invoice: PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        number: PropTypes.number,
        userId: PropTypes.number,
        payerType: PropTypes.string,
    }),
};

export default TitleWithStatus;
